export default __webpack_public_path__ + "static/media/JobSix10.d6e559da.jpg";